import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            background-size: cover;
            background-repeat: no-repeat;
            @media (max-width:767px) {
                background-size: 100%;
                margin-top: 100px;
                height: 250px;                
            }
        `

        const Overlay = styled.div`
            width: 100%;
            display: flex;
            align-items: center;
            background-color: rgba(0,0,0,.4);
            @media (max-width:767px) {                
                height: 250px !important;            
            }            
        `

        const Heading1 = styled.h1`
            font-size: 80px;
            font-family: Poppins;
            line-height: 80px;
            color: #c1eb18;
            font-weight: bold;
            text-transform: uppercase;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
                padding-top: 100px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
                margin-left: 2px;
            }
        `

        const Heading2 = styled.h2`
            font-size: 50px;
            color: #c1eb18;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18, #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 20px;
                line-height: 40px;
            }
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
        `
        
        const Content = styled.div`
            position: relative;
            z-index: 10;            
            @media (min-width:1025px) and (max-width: 1400px) {    
                margin-bottom: 200px;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #78c91c;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const BottomContent = styled.div`
            position: absolute;
            width: 100%;
            bottom: -24%;
            z-index: 2;
            @media (min-width:1025px) and (max-width: 1400px) {    
                bottom: -50%;
            }
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }            
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading3 = styled.h3`
            font-size: 30px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `        
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #65ff00;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 14px;
            font-weight: 300;
            color: #c5c5c5;
        `
        const Color = styled.span`            
            font-weight: bold;
            color: #65ff00;            
        `

        const { data } = this.props;
        const imageData = getImage(data.background.childImageSharp.gatsbyImageData);
        
        return (
            <Section>
                <Overlay style={{ height: `${this.state.width > 500 ? this.state.height : 350}px` }}>
                    <GatsbyImage
                        image={imageData}
                        alt="Certimail VASCO Solutions"
                        style={{ position: 'absolute', width: '110%', height: '100%', opacity: 0.8 }}
                    />
                    <Container>
                        <Content>
                            <Heading1>
                                Certimail
                            </Heading1>
                            <Heading2>
                                Correo Electrónico Certificado
                            </Heading2>
                            <Separator />

                        </Content>
                    </Container>
                </Overlay>
                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="Correo Electrónico seguro" />
                                        </ServiceIcon>
                                        <ServiceHeading3>
                                            Correo electrónico seguro
                                        </ServiceHeading3>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Obtenga un cifrado sólido de extremo a extremo entre usted y sus contactos utilizando Sectigo SMIME. El certificado garantiza
                                            que el correo nunca pueda ser interceptado, ni descifrado por atacantes MIM (Man-In-The-Middle), servidores proxy https o
                                            rastreadores de paquetes.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Firma de documentos Certimail" />
                                        </ServiceIcon>
                                        <ServiceHeading3>
                                            Firma de documentos
                                        </ServiceHeading3>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Los <Color>certificados SMIME</Color> permiten firmar cualquier documento personal o empresarial para confirmar la identidad del firmante.
                                            Esto ayuda a dejar de utilizar flujos de trabajo basados en tinta y papel en elementos como contratos, firmas de documentos o
                                            documentos internos.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Autenticación de clientes Certimail" />
                                        </ServiceIcon>
                                        <ServiceHeading3>
                                            Autenticación del cliente
                                        </ServiceHeading3>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Los certificados S/MIME también se utilizan para autenticar a los clientes de manera segura en entornos en línea, lo que quiere
                                            decir que le permite aumentar la protección de su red, aplicaciones y servidores con <Color>autenticación de dos factores</Color> basada en certificados.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {
          background: file(relativePath: { eq: "certificado-email.jpg" }) {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED, width: 2000)
                    }
          }
          image1: file(relativePath: { eq: "icons/email.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/documentos.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/autenticacion.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }          
        }
      `}
        render={(data) => {            
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            return <Hero data={data} image1={image1} image2={image2} image3={image3}{...props} />;
        }}
    />
);

export default Iconos;
